//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'CrmebOaEntCommentList',
  props: ['commentList'],
  data: function data() {
    return {
      userId: JSON.parse(localStorage.getItem('userInfo')).id
    };
  },
  methods: {
    replyFn: function replyFn(data, row) {
      this.$emit('replyFn', data, row);
    },
    commentDel: function commentDel(data) {
      this.$emit('commentDel', data);
    }
  }
};